import React, { useEffect, useState } from 'react'
import './Navbar.scss';

export default function StickyNavbar() {

    const [scroll, setScroll] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > window.innerHeight);
        });
    });

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    return (
        <section className=''>
            <header className={`headerMain tw-inset-x-0 tw-bottom-0 ${scroll ? "sticky fixed" : ""}`}>
                <div class="nav-items-md tw-p-8 tw-uppercase tw-justify-center tw-flex tw-content-evenly tw-gap-[60px]">
                    <div onClick={scrollToTop}>
                        Top
                    </div>
                    <div>
                        <a href='#about-us'>About Us</a>
                    </div>
                    <div>
                        <a href='#menu'>Menu</a>
                    </div>
                    {/* <div>
                        <a href='#special'>Specials</a>
                    </div> */}
                    <div>
                        <a href='#gallery'>Gallery</a>
                    </div>
                    <div>
                        <a href='#timing'>Timing</a>
                    </div>
                    <div>
                        <a href='#contact'>Contact</a>
                    </div>
                </div>
            </header>
        </section>

    );
}
